import { ajax } from 'rxjs/observable/dom/ajax';
import { Observable } from 'rxjs';
import * as actions from '../actions';
import { loginUrl } from '../utils/apiHelper';
import { ActionTypes, LAST_PAGE_KEY } from '../constants';
import {
  getCookie,
  SessionStorageUtil,
  getQueryParamValue,
  getSubdomain,
} from '../utils';
import { JS_VALUES } from '../constants';
export function redirectToCommandCenter({ response }) {
  if (response && response.resultCode === 'FAILURE') {
    return actions.setError(response.resultMessage);
  }
  const sessionState = getQueryParamValue(window.location, 'session_state');
  if (!sessionState) {
    return actions.setError('Error failed to authenticate');
  }
  const lastVisitFromStorage = SessionStorageUtil.getFromSessionStorage(
    LAST_PAGE_KEY
  );
  const lastVisitUrl =
    lastVisitFromStorage &&
    lastVisitFromStorage !== JS_VALUES.NULL &&
    lastVisitFromStorage !== JS_VALUES.UNDEFINED
      ? lastVisitFromStorage
      : '';
  const url = `/?session_state=${sessionState}${lastVisitUrl}`;
  // location.replace unlike location.href is replacing the current URL with the destination URL
  // so if the user will click the back button he won't be directed to the SSO app
  window.location.replace(url);
}

export function postSSOEpic(action$) {
  return action$
    .ofType(ActionTypes.HANDLE_POST_SSO_STAGE)
    .mergeMap(({ payload }) => [
      actions.setSSOStage(payload.ssoStage),
      actions.loginToCommandCenter(getQueryParamValue(window.location, 'code')),
    ]);
}

export function loginToCommandCenterEpic(action$) {
  var csrfHeader = getCookie('XSRF-TOKEN');
  return action$
    .ofType(ActionTypes.LOGIN_TO_COMMAND_CENTER)
    .mergeMap(({ payload }) =>
      ajax({
        url: loginUrl(),
        method: 'POST',
        crossDomain: true,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;UTF-8',
          'X-XSRF-TOKEN': csrfHeader,
        },
        body: {
          authorizationCode: payload.accessToken,
          subDomainUrl: getSubdomain(window.location),
        },
      })
        .map(resp => redirectToCommandCenter(resp))
        .catch(error => Observable.of(actions.setError(error.message)))
    );
}



// WEBPACK FOOTER //
// ./src/epics/postSSOEpics.js